<div class="ya-bottomsheet-container ya-typography">
  <ya-bottomsheetclosebottom [bottomSheetRef]="bottomSheetRef"></ya-bottomsheetclosebottom>
  <div class="ya-bottomsheet-content-center">
    <div class="ya-bottomsheet-title-icon">
      <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-impressum"></div>
    </div>
    <h2 langkey="phInHouseLocalBasket_ImpressumDialog"></h2>
    <div class="ya-dialog-content">
      <div class="impressumlocation-dialog-content" [innerHtml]="modalImpressumData.impressumHtml"></div>
    </div>
  </div>
</div>